import { useAuth } from "@/auth/AuthContext";
import { authGateDecision } from "@/auth/authGate";
import { useTheme } from "@/theme/ThemeProvider";
import { Redirect, usePathname } from "expo-router";
import { ActivityIndicator, Platform, StyleSheet, Text, View } from "react-native";

/**
 * Einzige Auth-Schranke. Der Navigator bleibt gemountet;
 * solange die Session fehlt oder noch lädt, liegt ein Overlay darüber.
 */
export function AuthGate({ children }: { children: React.ReactNode }) {
  const { authReady, session } = useAuth();
  const pathname = usePathname();
  const { theme } = useTheme();
  const decision = authReady ? authGateDecision(pathname, Boolean(session)) : null;
  const blocked = !authReady || decision !== null;

  return (
    <>
      {children}
      {blocked ? (
        <View
          style={[
            styles.loading,
            { backgroundColor: theme.color.bg },
            Platform.OS === "web" && styles.loadingWeb,
          ]}
        >
          {decision ? <Redirect href={decision} /> : null}
          <ActivityIndicator size="large" color={theme.color.primary} />
          <Text style={[styles.loadingText, { color: theme.color.text }]}>Laden…</Text>
        </View>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  loading: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: "center",
    alignItems: "center",
    zIndex: 20,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
  },
  loadingWeb: {
    minHeight: "100vh" as unknown as number,
  },
});
